import { Injectable } from '@angular/core';
import Keycloak from 'keycloak-js';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly keycloak = new Keycloak({
    url: environment.keycloak.url,
    realm: environment.keycloak.realm,
    clientId: environment.keycloak.clientId,
  });

  get username(): string {
    return this.keycloak.tokenParsed?.['preferred_username'] ?? '';
  }

  get firstName(): string {
    return this.keycloak.tokenParsed?.['given_name'] ?? '';
  }

  get lastName(): string {
    return this.keycloak.tokenParsed?.['family_name'] ?? '';
  }

  get email(): string {
    return this.keycloak.tokenParsed?.['email'] ?? '';
  }

  async init(): Promise<void> {
    await this.keycloak.init({
      onLoad: 'login-required',
      pkceMethod: 'S256',
      checkLoginIframe: false,
    });
  }

  async getToken(): Promise<string> {
    try {
      await this.keycloak.updateToken(30);
    } catch {
      await this.keycloak.login();
    }
    return this.keycloak.token ?? '';
  }

  logout(): void {
    void this.keycloak.logout({ redirectUri: window.location.origin });
  }
}
